const packagePrices = {
    1: "950",
    2: "1100",
    3: "1500"
}

export default packagePrices;